import { Fab as MuiFab } from '@mui/material'

interface FabProps {
  children: React.ReactNode
  style?: any
  onClick: VoidFunction
  disabled?: boolean
}

export const Fab = (props: FabProps) => {
  const { children, style, onClick, disabled } = props

  return (
    <MuiFab style={style} onClick={() => onClick()} disabled={disabled}>
      {children}
    </MuiFab>
  )
}
